import React from "react";
import Seo from "../components/Seo";
import { organizationJsonLd } from "../seo/organizationSchema";
import { jsonLdWithMedia } from "../seo/mediaSchema";
import HomeHero from "../components/home/HomeHero";
import HomePartnerMarquee from "../components/home/HomePartnerMarquee";
import HomeTechnology from "../components/home/HomeTechnology";
import HomeMagLab from "../components/home/HomeMagLab";
import HomeProblem from "../components/home/HomeProblem";
import HomeCaseStudies from "../components/home/HomeCaseStudies";
import HomeFinalCta from "../components/home/HomeFinalCta";

export default function Home() {
  return (
    <>
      <Seo
        title="Manufacturing Automation Group | AGV & AMR Integrator"
        description="Manufacturing Automation Group (MAG): Metro Detroit based turnkey integrator of AGV and AMR systems for high-intensity manufacturing. One partner, not six."
        path="/"
        image="https://www.mag-automate.com/images/Image.jpg"
        jsonLd={jsonLdWithMedia("/", organizationJsonLd, {
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "Manufacturing Automation Group",
          url: "https://www.mag-automate.com/",
          publisher: { "@id": "https://www.mag-automate.com/#organization" },
        })}
      />
      <HomeHero />
      <HomePartnerMarquee />
      <HomeTechnology />
      <HomeMagLab />
      <HomeProblem />
      <HomeCaseStudies />
      <HomeFinalCta />
    </>
  );
}
